export default {
    CustomerList: {
        ChooseCustomer: 'Vyberte zákazníka',
    },

    Customer: {
        SafesOnline: 'Připojené trezory',
        CurrentBalance: 'Aktuální zůstatek',
        DailySales: 'Denní tržby',
        ActiveWarnings: 'Aktivní upozornění',
        Of: 'z',
        In: 'V',
        Branches: 'Pobočky'
    },

    Branch: {
        ExportTransactions: "Exportovat transakce",
        ManageOperators: "Upravit operátory",
        ShowOnMap: "Zobrazit na mapě",
        CurrentBalance: "Aktuální zůstatek",
        DailySales: 'Denní tržby',
        MainCurrency: 'Hlavní měna',
        TransactionDays: 'Den transakce'
    },

    BranchList: {
        Name: 'Název',
        Status: 'Status',
        BalanceAmount: 'Zůstatek',
        BalanceCurrency: 'Měna zůstatku',
        LastBalance: 'Aktualizováno',
        Branches: 'Pobočky',
    },

    BranchListFilter: {
        Branches: 'Pobočky',
        SearchCriteria: 'Hledat pobočku...',
    },

    Chart: {
        Sales: 'Tržby',
        Pickup: 'Odvod',
        Balance: 'Zůstatek',
        Difference: 'Diference',
        Confirmed: 'Potvrzeno',
        DepositsAndPickups: 'Vklady a odvody',
        NoDataAvailable: 'Žádná data k dispozici',
        SafebagBalance: 'Zůstatek v Safebagu',
        RecyclableBalance: 'Recyklovatelný zůstatek',
        ManualDepositBalance: 'Zůstatek ručního vkladu',
        OverflowBalance: 'Zůstatek přebytku'
    },

    ChartDenominations: {
        Deposited: 'Vloženo',
        Recyclable: 'Recyklovatelné',
        Denominations: 'Hodnoty bankovek',
        NoDataAvailable: 'Žádné'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Zpracovaný vklad',
        UnprocessedSales: 'Nezpracovaný vklad',
        SalesOut: 'Výběr',
        SalesPerHour: 'Tržby za hodinu'
    },

    CustomerHeader: {
        ShowOnMap: 'Zobrazit na mapě',
        Branches: 'Pobočky',
        Branch: 'Pobočka',
        ExportTransactions: 'Exportovat transakce',
    },

    DeviceStatus: {
        AllOk: 'Vše v pořádku',
    },

    DeviceStatusList: {
        Safes: 'Trezory',
    },

    ExportForm: {
        ExportTransactions: 'Exportovat transakce',
        Cancel: 'Zrušit',
        Export: 'Export',
        FromDate: 'Od data',
        Time: 'Čas',
        EndDate: 'Do data'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Zapomněli jste heslo?',
        ForgotText: 'Prosím zadejte Vaší e-mailovou adresu a klikněte na tlačítko. Příjde Vám e-mail s dalšími instrukcemi.',
        LoginLink: 'Zpět k přihlášení',
        EmailAddress: 'Emailová adresa',
        Submit: 'Odeslat email',
        ErrorMessage: 'Nebylo možné odeslat Váš požadavek na server'
    },

    LoginPage: {
        LoginHeader: 'Vítejte',
        LoginText: 'Níže se přihlašte pomocí Vaší emailové adresy a hesla',
        LoginForgot: 'Zapomněli jste heslo?',
        Username: 'E-MAIL',
        Password: 'HESLO',
        Login: 'Přihlásit se'
    },

    ResetPasswordPage: {
        ResetHeader: 'Obnovit heslo',
        ResetText: 'Zadejte nové heslo.'
    },

    Drawer: {
        Dashboard: 'Nástěnka',
        SwitchCustomer: 'Přepnout zákazníka',
        MyProfile: 'Můj profil',
        Logout: 'Odhlásit'
    },

    OperatorForm: {
        UserId: 'ID uživatele',
        FirstName: 'Jméno',
        LastName: 'Příjmení',
        Pin: 'PIN',
        Save: 'Uložit',
        Delete: 'Smazat',
        Operator: 'Operátora'
    },

    OperatorList: {
        AddOperator: 'Přidat operátora',
        Operators: 'Operátoři',
        Name: 'Jméno',
    },

    Profile: {
        Profile: 'Profil',
        Name: 'Jméno',
        Language: 'Jazyk',
        Password: 'Heslo',
        ConfirmPassword: 'Potvrdit heslo',
        Update: 'Aktualizovat'
    },

    ResetPasswordForm: {
        NewPassword: 'Nové heslo',
        ConfirmPassword: 'Potvrdit heslo',
        Submit: 'Odeslat'
    },

    InviteUserForm: {
        InviteHeader: 'Pozvaný uživatel',
        InviteText: 'Vyplňte prosím příslušné údaje a stiskněte Uložit, abyste se mohli přihlásit.',
        Name: 'Jméno',
        Language: 'Jazyk',
        NewPassword: 'Nové heslo',
        ConfirmPassword: 'Zopakujte nové heslo',
        Submit: 'Uložit'
    },

    TransactionList: {
        Type: 'Typ',
        Operator: 'Operátor',
        When: 'Kdy',
        Amount: 'Částka',
        Currency: 'Měna',
        Transactions: 'Transakce',
        Device: 'Zařízení',
        SalesDay: 'Den tržby',
        HoverDeposit: 'Zůstatek',
        HoverSalesIn: 'Vklad',
        HoverSalesOut: 'Výběr',
        HoverManualDeposit: 'Ruční vklad',
        HoverCollection: 'Odvod',
        HoverCollectionNotes: 'Odvod bankovek',
        HoverCollectionCoins: 'Odvod mincí',
        HoverCollectionEnvelope: 'Odvod ručního vkladu',
        HoverCollectionOK: 'Odvod potvrzený',
        HoverCollectionNotesOK: 'Odvod potvrzených bankovek',
        HoverCollectionCoinsOK: 'Odvod potvrzených mincí',
        HoverCollectionEnvelopeOK: 'Odvod potvrzených ručních vkladů',
        HoverCollectionNOK: 'Odvod diferencí',
        HoverCollectionNotesNOK: 'Odvod bankovek s diferencí',
        HoverCollectionCoinsNOK: 'Odvod mincí s diferencí',
        HoverCollectionEnvelopeNOK: 'Odvod ručních vkladů s diferencí',
        HoverDrain: 'Odstranění',
        HoverRefill: 'Naplnit',
        HoverExchange: 'Směna',
        HoverExchangeIn: 'Vybrat cizí měnu',
        HoverExchangeOut: 'Vložit cizí měnu',
        HoverCounterfeit: 'Padělky',
        HoverInternal: 'Vnitřní transakce',
        HoverNOP: 'Žádná operace'
    },

    TransactionDayList: {
        Date: "Datum",
        Sales: "Tržby",
        Pickup: "Výběr",
        Balance: "Zůstatek",
        TransactionDays: "Den transakce"
    },

    TransactionDay: {
        Date: "Datum",
        Sales: "Tržby",
        Pickup: "Výběr",
        Balance: "Zůstatek",
        TransactionDays: "Den transakce",
        ExportTransactions: 'Exportovat transakce',
    },

    TransactionDatePicker: {
        Date: 'Datum'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/cz.js